import { combineReducers } from 'redux';
// import addToCartReducer from './addToCartReducer';
import initCardReducer from './initCardReducer';
import cartData from './cartReducer';
import setAddedBundle from './setAddedBundleReducer';
import setFlyoutState from './updateFlyoutStateReducer';
import flyoutFormUpdate from './flyoutFormUpdateReducer';

export default combineReducers({
	// cartState: addToCartReducer,
	initCardData: initCardReducer,
	cart: cartData,
	addedBundle: setAddedBundle,
	flyoutOpen: setFlyoutState,
	bundleUpdates: flyoutFormUpdate,
});
